import http from "./httpServices";

export async function addProduct(data) {
  try {
    const res = await http.post("/addProducts.php", data);
    return res;
  } catch (error) {
    console.error("Upload product error:", error);
    throw error;
  }
}

export async function getProducts() {
  try {
    const res = await http.get("/getProducts.php");
    return res.data;
  } catch (error) {
    console.error("Get products error:", error);
    throw error;
  }
}

export async function deleteProduct(id) {
  try {
    const res = await http.delete(`/deleteProduct.php?id=${id}`);
    return res;
  } catch (error) {
    console.error("Delete product error:", error);
    throw error;
  }
}

export async function updateProducts(data) {
  try {
    const res = await http.post("/updateProducts.php", data);
    return res;
  } catch (error) {
    console.error("Update product error:", error);
    throw error;
  }
}

export async function loginCustomer(data) {
  return await http.post("/login.php", data);
}

export async function registerCustomer(data) {
  return await http.post("/register.php", data);
}

export async function checkoutOrder(data) {
  try {
    const res = await http.post("/checkout.php", data);
    return res;
  } catch (error) {
    console.error("Checkout order error:", error);
    throw error;
  }
}

export async function getOrder(data) {
  try {
    const res = await http.post("/getOrder.php", data);
    return res;
  } catch (error) {
    console.error("Get order error:", error);
    throw error;
  }
}

export async function deleteOrder(id) {
  try {
    const res = await http.post("/deleteOrder.php", {
      order_id: id,
    });

    return res;
  } catch (error) {
    console.error("Delete order error:", error);
    throw error;
  }
}

export async function getPendingOrders() {
  try {
    const res = await http.get("/getPendingOrders.php");
    return res;
  } catch (error) {
    console.error("Get pending orders error:", error);
    throw error;
  }
}

export async function confirmOrder(data) {
  try {
    const res = await http.post("/confirmOrder.php", data);
    return res;
  } catch (error) {
    console.error("Confirm order error:", error);
    throw error;
  }
}

export async function deleteItem(data) {
  try {
    const res = await http.post("/deleteItem.php", data);
    return res;
  } catch (error) {
    console.error("Delete item error:", error);
    throw error;
  }
}

export async function getCompletedOrders() {
  try {
    const res = await http.get("/getCompletedOrders.php");
    return res;
  } catch (error) {
    console.error("Get completed orders error:", error);
    throw error;
  }
}

export async function updateRating(data) {
  try {
    const res = await http.post("/updateRating.php", data);
    return res;
  } catch (error) {
    console.error("Update rating error:", error);
    throw error;
  }
}
